import * as React from 'react'
export const EmailSupportIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={85} height={84} fill="none" {...props}>
    <g filter="url(#a)">
      <circle cx={42.5} cy={42} r={22} fill="#fff" />
    </g>
    <g clipPath="url(#b)">
      <path
        fill="#E12468"
        d="M53.396 30.281c-.282-.187-.564-.281-.846-.281-.281 0-.516.094-.751.234L30.757 42.187c-.517.329-.799.844-.752 1.407 0 .515.376 1.031.893 1.265l4.837 2.016 2.912 6.89c.094.188.235.235.33.235.093 0 .187 0 .234-.094l4.04-3.843 5.636 2.343c.235.094.422.094.61.094.282 0 .564-.094.705-.188.423-.187.704-.609.751-1.078l3.006-19.453a1.402 1.402 0 0 0-.563-1.5ZM31.508 43.5l17.848-10.172-13.574 12-4.274-1.828Zm7.89 8.203-2.3-5.531 10.755-9.516-7.937 10.922a.812.812 0 0 0-.141.656c.094.235.235.422.47.47l1.596.655-2.442 2.344Zm10.146-.89L41.7 47.672 52.27 33.14l-2.725 17.672Z"
      />
    </g>
    <defs>
      <clipPath id="b">
        <path fill="#fff" d="M30 30h24v24H30z" />
      </clipPath>
      <filter
        id="a"
        width={84}
        height={84}
        x={0.5}
        y={0}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={10} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_10204_271025" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_10204_271025" result="shape" />
      </filter>
    </defs>
  </svg>
)
